###
  Formats http request method name as a translated crud operation result
###
angular
	.module 'App.Filter'
	.filter 'wmApiActionResult',
		[
			"$filter"
			($filter) ->
				return (httpRequestMethod, hasError = false) ->
					alertType = "alert."
					httpRequestMethod = httpRequestMethod.toUpperCase()

					if hasError
						alertType += 'error'
					else
						switch httpRequestMethod
							when "POST" then alertType += 'saved'
							when "GET" then alertType += 'loaded'
							when "PUT" then alertType += 'updated'
							when "DELETE" then alertType += 'deleted'
							else alertType += 'confirmed'

					return $filter('translate')(alertType)
		]
